import React from 'react';

import {
  AppBar,
  Box,
  IconButton,
  Link,
  Toolbar,
} from '@mui/material';

import { teal, orange, green } from '@mui/material/colors';

import MenuIcon from '@mui/icons-material/Menu';

import UserMenu from './UserMenu';
import FormDrawer from './FormDrawer';

import useNavigateWithConfirm from '../core/hooks/useNavigateWithConfirm';
import SvgIconHelpDocument from '../assets/svg/SvgIconHelpDocument';

function ApplicationBar() {
  const navigateWithConfirm = useNavigateWithConfirm();
  const [isDrawerOpen, setIsDrawerOpen] = React.useState<boolean>(false);
  const handleToggleDrawer = () => setIsDrawerOpen((prevState: boolean) => !prevState);

  return (
    <React.Fragment>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleToggleDrawer}
          >
            <MenuIcon />
          </IconButton>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            noWrap
            component="button"
            variant="h6"
            color="inherit"
            underline="none"
            onClick={() => navigateWithConfirm('/')}
          >
            Air Wisconsin | Operational Reporting Database
          </Link>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton
            href="api/metadata/help?formName=forms-help.pdf"
            target="_blank"
            sx={{ mr: 3 }}
          >
            <SvgIconHelpDocument />
          </IconButton>
          <UserMenu />
        </Toolbar>
      </AppBar>
      <FormDrawer open={isDrawerOpen} toggleOpen={handleToggleDrawer} />
    </React.Fragment>
  );
}

export default ApplicationBar;
